export const LandingPageCarouselTabPTBRTranslations = {
  carouselTabButtonLabel: 'Botão para alterar a aba do carrossel',
};
